function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}

// Use for converting the loadOptions to query parameters for the server
export const getLoadOptionsParams = (loadOptions) => {
  let params = "?";

  // Handling skip and take when All option from paging is selected
  if (isNotEmpty(loadOptions.take) && loadOptions.take !== "all") {
    params += `skip=${JSON.stringify(loadOptions.skip || 0)}&`;
    params += `take=${JSON.stringify(loadOptions.take)}&`;
  } else {
    params += `skip=0&`;
    params += `take=0&`;
  }
  [
    "requireTotalCount",
    "requireGroupCount",
    "sort",
    "filter",
    "totalSummary",
    "group",
    "groupSummary",
  ].forEach(function (i) {
    if (i in loadOptions && isNotEmpty(loadOptions[i])) {
      params += `${i}=${encodeURIComponent(JSON.stringify(loadOptions[i]))}&`;
    }
  });
  params = params.slice(0, -1);
  return params;
};
